export const FETCH_ASSET_TYPE_LIST_END = "FETCH_ASSET_TYPE_LIST_END";
